import React from 'react'
import { Link } from 'react-router-dom'
import { scrollToElement, scrollTop } from '../../common/lib/scroll'

class AnchorLink extends React.Component {
  render() {
    const { to, children, className, onClick } = this.props
    const splited = to.split('#')
    const hash = (splited.length > 1) ? splited[splited.length - 1] : ''
    if (hash) {
      return (
        <div
          onClick={() => {
            scrollToElement(hash)
            if (onClick) onClick()
          }}
        >
          <Link to={to} className={className}>
            {children}
          </Link>
        </div>
      )
    }
    return (
      <div onClick={() => { scrollTop() }}>
        <Link to={to}>{children}</Link>
      </div>
    )
  }

}

AnchorLink.propTypes = {
  children: React.PropTypes.any,
  to: React.PropTypes.string.isRequired,
}

export default AnchorLink



// WEBPACK FOOTER //
// ./src/browser/components/AnchorLink.js